import { render, staticRenderFns } from "./IconSvgMpeg.vue?vue&type=template&id=7652144d&scoped=true&"
import script from "./IconSvgMpeg.vue?vue&type=script&lang=js&"
export * from "./IconSvgMpeg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7652144d",
  null
  
)

export default component.exports